const HeadSectionStyle = {
  title: {
    padding: 'calc(1vh)',
  },
  content: {
    paddingLeft: { xs: 'calc(0vh)', sm: 'calc(0.5vh)', lg: 'calc(3vh)' },
    paddingRight: { xs: 'calc(0vh)', sm: 'calc(0.5vh)', lg: 'calc(0vh)' },
  },
  detail: {
    px: 'calc(1vh)',
    marginRight: { xs: 'calc(2vw)', lg: '0vw' },
    paddingRight: 'calc(2vw)',
  },
  image: {
    marginTop: '14%',
    display: { xs: 'none', lg: 'block' },
    overflowX: 'hidden',
  },
};

export default HeadSectionStyle;
